import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const ArrowDecisionUp: FC<IconSVGComponentProps> = (props) => {
    return (
        <IconSVG viewBox="0 0 24 24" {...props}>
            <IconPath
                fill="currentColor"
                d="M12 4L9 7M12 4L15 7M12 4V12M3 14L6 17M3 14L6 11M3 14H6C8 14 12 15.2 12 20C12 15.2 16 14 18 14H21M21 14L18 17M21 14L18 11"
            />
        </IconSVG>
    );
};
